
import { CommApiInstance } from "Utils/CommApiInstance";


const FindPwEmlAthnNoSendApi = async (
    athnPrpsCd:string        ,
    loginId:string           ,
    ReCaptchaToken:string    ,
) => {
    return await CommApiInstance.post(`athn/idnt_mthd/eml/athn_no_send/login_id`,{
        apiBody: {
            athnPrpsCd:athnPrpsCd,
            loginId:loginId,
            cptchTkn:ReCaptchaToken,
        }
    })
    .then((Resp) => Resp.data);
}

export default FindPwEmlAthnNoSendApi;